import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { HOME_SERVICE_URI } from '@cores/constants/envConfig';
export class EmailAlertStatusApiImpl extends PsHttpService {
    get options() {
        return {
            baseURL: `${HOME_SERVICE_URI}/email-alert-api`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }
    async getFolderEmailAlertStatusApi(folderId) {
        const res = await this.get({
            url: '/emailalert/alert/search',
            transformCode: true,
            params: {
                folder_id: folderId,
            },
        });
        return res.data;
    }
}
